import { Component, OnInit } from '@angular/core';
import { FavoriteService } from 'src/app/services/favorite.service';
import { AccessUserInfo } from 'src/app/models';

@Component({
  selector: 'bart-settings-main',
  templateUrl: './settings-main.component.html',
  styleUrls: ['./settings-main.component.scss']
})
export class SettingsMainComponent implements OnInit {
  
  userDetail :any  =null;
  constructor(private _FavoriteService:FavoriteService) { 
    this.userDetail = AccessUserInfo.getUserInfo();
  }

  ngOnInit() {
  }

  
  public async checkFavoriteListName (favoriteListName: string,favoriteListTypeId: number,favoriteListId:string)
    {
     
      let nameExists:boolean= false;
 
      var GETFAVORITELIST:any = { favoriteListName:favoriteListName, favoriteListTypeId:favoriteListTypeId,
        favoriteListId:favoriteListId,check:1
      ,userId:this.userDetail.userId };
        
      await this._FavoriteService.getFavoriteListSync(JSON.stringify({GETFAVORITELIST}) )
      .then((listsResponse: any) => {
      
       let favoriteData = listsResponse;
        
       if(favoriteData.records.length > 0)
       {
        nameExists = true;

       }
      }
      );
      
      return nameExists;
    }

}
